import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { CardsPreviewGroup } from '@shared/ui/parts';
import { useTranslation } from 'react-i18next';
import { useCards } from '@app/api/cards/useCards';
import { useState } from 'react';

export default function DeleteCardDialog({ close, data }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { deleteCards } = useCards();

  async function onSubmit() {
    setIsLoading(true);
    try {
      const res = await deleteCards({ card_ids: data.map((x) => x.id) });
      if (res) close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <CardsPreviewGroup data={data} label={t('are_you_sure_delete_cards')} />
        <br />
        <Note
          type="warning"
          title={t('this_operation_cannot_be_undone')}
          content={t('cards_delete_note')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="delete"
            onClick={onSubmit}
            loading={isLoading}
          >
            {t('yes_delete')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
